var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.value.side == _vm.EMPLOYMENT_FIELD_SIDES.DOCUMENT.value ? [_c('v-simple-checkbox', {
    attrs: {
      "value": _vm.value.data,
      "color": "primary"
    }
  })] : [false ? void 0 : _vm.mode == 'done' ? [_c('v-simple-checkbox', {
    attrs: {
      "value": _vm.value.data,
      "color": "primary"
    }
  })] : _vm.mode == 'sign' ? [_c('v-simple-checkbox', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.emit
    },
    model: {
      value: _vm.form.data,
      callback: function ($$v) {
        _vm.$set(_vm.form, "data", $$v);
      },
      expression: "form.data"
    }
  })] : [_c('span', {
    staticStyle: {
      "opacity": "0.5",
      "word-break": "auto-phrase"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.term) + " ")])]]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }